import React from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton'
import { contactUs } from '../modules/contact'
import { message } from '../../../store/messageBar'
import { connect } from 'react-redux'

class ContactForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            errors: {},
            form: {}
        }
    };

    handleSubmit = () => {
        this.props.contactUs(this.state.form.email,
            this.state.form.name,
            this.state.form.message,
            this.state.form.phone).then(() => {

            this.setState({form: {
                name: '',
                email: '',
                message: '',
                phone: '',
            }});
            this.props.showMessage('Message was sent');
        }).catch(error => {
            if (error.response && error.response.data) {
                this.props.showMessage(error.response.data.error);
            }
        });
    };

    handleInput = (e) => {
        let form = this.state.form;
        form[e.target.id] = e.target.value;
        this.setState({form: form});
    };


    render = () => {
        return (
            <Card>
                <CardHeader className={'form-title contact-form-title'} title='Contact form'/>
                <CardText>
                    <div>
                        <TextField
                            hintText='Name'
                            floatingLabelText='Name'
                            id={'name'}
                            onChange={this.handleInput}
                            underlineFocusStyle={{ borderColor: "#333c8f" }}
                            floatingLabelStyle={{ color: "#333c8f" }}
                            value={this.state.form.name}
                        />
                    </div>
                    <div>
                        <TextField
                            hintText='Phone'
                            floatingLabelText='Phone'
                            id={'phone'}
                            onChange={this.handleInput}
                            underlineFocusStyle={{ borderColor: "#333c8f" }}
                            floatingLabelStyle={{ color: "#333c8f" }}
                            value={this.state.form.phone}
                        />
                    </div>
                    <div>
                        <TextField
                            hintText='Email'
                            floatingLabelText='Email'
                            id={'email'}
                            onChange={this.handleInput}
                            underlineFocusStyle={{ borderColor: "#333c8f" }}
                            floatingLabelStyle={{ color: "#333c8f" }}
                            value={this.state.form.email}
                        />
                    </div>
                    <div>
                        <TextField
                            hintText='Message'
                            floatingLabelText='Message'
                            id={'message'}
                            onChange={this.handleInput}
                            multiLine={true}
                            rows={3}
                            rowsMax={9}
                            fullWidth={true}
                            underlineFocusStyle={{ borderColor: "#333c8f" }}
                            floatingLabelStyle={{ color: "#333c8f" }}
                            value={this.state.form.message}
                        />
                    </div>
                    <div>
                        <RaisedButton
                            className={'submit-btn'}
                            onClick={this.handleSubmit}
                            type='submit'
                            label='Submit'
                            secondary={true}
                        />
                    </div>
                </CardText>
            </Card>
        )
    }

}


const mapStateToProps = (state, props) => {
    return { }
};

const mapDispatchToProps = (dispatch) => {
    return {
        contactUs: (email, name, message, phone) => contactUs(email, name, message, phone),
        showMessage: (text) => dispatch(message(text))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactForm);



// WEBPACK FOOTER //
// ./src/routes/ContactUs/components/ContactForm.js